import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { ToggleModel } from '../../../../utils/pageUtils';
import { Store } from '../../index';
import { Registration } from '../../services/Registration';
import { Spinner } from '../../../../components/spinner/index';
import { FormModel } from '../../../../components/form/Model';
import { FormField } from '../../../../components/input/index';
import { Button, Intent } from '@blueprintjs/core/dist';
import * as AWS from 'aws-sdk';
import { randomUUID } from "../../../../utils/uuid";

const bannerImage = require('../../resources/bannerImage.png');

const s3 = new AWS.S3({
  credentials: {
    accessKeyId: 'AKIAIZG3CRN4IIWCBL3Q',
    secretAccessKey: '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',
  },
  region: 'us-east-1'
});

@inject('store')
@observer
export class RegistrationForm extends React.Component<{
  store?: typeof Store.Type,
  registrationToggle: typeof ToggleModel.Type
}, {}> {
  componentWillMount() {
    this.props.store!.registration.setInstance(Registration.create());
  }
  render() {
    const { registration } = this.props.store!;
    const form = registration.forms[0];
    return registration.state === 'done' ? (
      <RegistrationFormComponent
        form={form}
        onSave={() => registration.save().then(r => {
          if (r) {
            s3.upload({
              Bucket: 'bcoms2018',
              Key: randomUUID(),
              ACL: 'public-read',
              Body: JSON.stringify(r),
              ContentType: 'application/json',
            }).promise().then(res => {
              this.props.registrationToggle.toggle();
              this.props.store!.app.view.currentView.changeView('eventpaymentpage');
            });
          }
        })
        }
      />
    ) : <Spinner />;
  }
}

const RegistrationFormComponent = observer((props: {
  form: FormModel,
  onSave: () => void
}) => (
    <div className="mt2 mh2 pt-card pt-interactive pt-elevation-2 animated fadeIn vh-75 overflow-scroll">
      <article className="cf">
        {props.form.error ?
          <div className="f6 db mv1 pt-intent-danger pt-tag">
            {props.form.error}
          </div> : undefined
        }
        <div className="fl w-100">
          <img src={bannerImage} alt="Registration form banner" className="w-100" />
        </div>
        <div className="fl w-50 pr2">
          <FormField field={props.form.$('name')} showLabels={true} />
          <FormField field={props.form.$('specialty')} showLabels={true} />
          <FormField field={props.form.$('institution')} showLabels={true} />
          <FormField field={props.form.$('mobile')} showLabels={true} />
          <FormField field={props.form.$('email')} showLabels={true} />
          <FormField field={props.form.$('numberOfAccompanyingPerson')} showLabels={true} />
          <FormField field={props.form.$('abstract')} showLabels={true} />
        </div>
        <div className="fl w-50">
          <FormField field={props.form.$('degree')} showLabels={true} />
          <FormField field={props.form.$('designation')} showLabels={true} />
          <FormField field={props.form.$('location')} showLabels={true} />
          <FormField field={props.form.$('phone')} showLabels={true} />
          <FormField field={props.form.$('faxNumber')} showLabels={true} />
          <FormField field={props.form.$('particularAccompanyingPerson')} showLabels={true} />
        </div>
        <div className="fl w-100">
          <p className="b">***Registration Fee:</p>
          <p className="b">1. For All Doctors - 6000 BDT</p>
          <p className="b">2. For Foreign Delegates- 100 US$</p>
        </div>
        <div className="fl w-100">
          <Button
            tabIndex={0}
            className="pt-fill"
            onClick={e => {
              e.preventDefault();
              props.onSave();
            }}
            intent={Intent.PRIMARY}
            type="submit"
            text="Submit"
            iconName="add"
          />
        </div>
      </article>
    </div>
  ));


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/pages/parts/Registration.tsx